module.exports = __webpack_public_path__ + "img/rope_ThimbleBraid_4.694cdf36.png";